import { isElectron } from '../utils/electron'
import './Download.css'

function Download() {
  // Don't show download page in Electron app
  if (isElectron()) {
    return (
      <div className="download-page container">
        <div className="already-installed">
          <h1>✅ App Instalada</h1>
          <p>Ya estás usando la app de escritorio.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="download-page container">
      <div className="download-hero">
        <h1>📺 Descarga la App de Escritorio</h1>
        <p>Para ver TV en vivo sin restricciones, descarga nuestra app para tu ordenador.</p>
      </div>

      <div className="download-cards">
        <div className="download-card">
          <div className="os-icon">🍎</div>
          <h2>macOS</h2>
          <p>Compatible con Intel y Apple Silicon</p>
          <a 
            href="https://github.com/pedrazo/movie-tracker/releases/latest/download/Pedrazo-Movie-Tracker.dmg" 
            className="btn btn-primary btn-lg"
            download
          >
            Descargar .dmg
          </a>
        </div>

        <div className="download-card">
          <div className="os-icon">🪟</div>
          <h2>Windows</h2>
          <p>Windows 10/11 (64-bit)</p>
          <a 
            href="https://github.com/pedrazo/movie-tracker/releases/latest/download/Pedrazo-Movie-Tracker-Setup.exe" 
            className="btn btn-primary btn-lg"
            download
          >
            Descargar .exe
          </a>
        </div>
      </div>

      <div className="download-instructions">
        <h3>📋 Instrucciones de instalación</h3>
        
        <div className="instructions-grid">
          <div className="instruction">
            <h4>macOS</h4>
            <ol>
              <li>Descarga el archivo .dmg</li>
              <li>Abre el archivo descargado</li>
              <li>Arrastra la app a la carpeta Aplicaciones</li>
              <li>Abre la app desde Aplicaciones</li>
            </ol>
          </div>

          <div className="instruction">
            <h4>Windows</h4>
            <ol>
              <li>Descarga el archivo .exe</li>
              <li>Ejecuta el instalador</li>
              <li>Sigue las instrucciones del instalador</li>
              <li>Abre la app desde el menú Inicio</li>
            </ol>
          </div>
        </div>
      </div>

      <div className="download-benefits">
        <h3>✨ Ventajas de la app de escritorio</h3>
        <ul>
          <li>✅ TV en vivo funciona sin restricciones</li>
          <li>✅ Mejor rendimiento</li>
          <li>✅ Acceso rápido desde el dock/taskbar</li>
          <li>✅ Actualizaciones automáticas</li>
        </ul>
      </div>
    </div>
  )
}

export default Download
